import PageEditTemplate from "../../templates/PageEditTemplate/PageEditTemplate";

const PageEditPage = () => {
  return <PageEditTemplate />;
};

export default PageEditPage;
